import type { StudentMe } from './types';

export type ProfileCtaState = 'empty' | 'partial' | 'complete';

export type ProfileProgress = {
  percent: number;
  state: ProfileCtaState;
};

const STUDENT_FIELD_COUNT = 7;

function filled(value: string | null | undefined): boolean {
  return Boolean(value?.trim());
}

export function computeStudentProfileProgress(
  student: StudentMe | null | undefined,
): ProfileProgress {
  if (!student) {
    return { percent: 0, state: 'empty' };
  }

  const profile = student.profile;
  const checks = [
    filled(profile?.displayName),
    filled(profile?.bio),
    filled(profile?.goals),
    filled(profile?.avatarUrl),
    filled(profile?.timezone),
    (profile?.nativeLanguages?.length ?? 0) > 0,
    (student.categoryIds?.length ?? 0) > 0,
  ];

  const done = checks.filter(Boolean).length;
  const percent = Math.round((done / STUDENT_FIELD_COUNT) * 100);

  if (percent >= 100) return { percent: 100, state: 'complete' };
  if (percent === 0) return { percent: 0, state: 'empty' };
  return { percent, state: 'partial' };
}
